module.exports = __webpack_public_path__ + "media/images/success/check_big-3659a02d2edd30def9adb41bc8815c39.png";